'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import type { ComponentType } from 'react';
import { useEffect } from 'react';
import ConsultationModal from '@/app/cc/_component/ui/modal/ConsultationModal/ConsultationModal';
import CouponPrivacyProvideModal from '@/app/cc/_component/ui/modal/CouponPrivacyProvideModal/CouponPrivacyProvideModal';
import { isModalKey, type ModalKey } from '@/app/cc/_types/modal';
interface BaseModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
const MODAL_MAP: Record<ModalKey, ComponentType<BaseModalProps>> = {
  consultation: ConsultationModal,
  couponPrivacyProvide: CouponPrivacyProvideModal
  // 추후 모달 추가 시 여기에만 등록
};
export function ModalManager() {
  const $ = _c(15);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let modalParam;
  let t0;
  if ($[0] !== searchParams) {
    modalParam = searchParams.get("modal");
    t0 = modalParam && isModalKey(modalParam) ? modalParam : null;
    $[0] = searchParams;
    $[1] = modalParam;
    $[2] = t0;
  } else {
    modalParam = $[1];
    t0 = $[2];
  }
  const modalKey = t0;
  let t1;
  let t2;
  if ($[3] !== modalKey || $[4] !== modalParam || $[5] !== pathname || $[6] !== router || $[7] !== searchParams) {
    t1 = () => {
      if (!modalParam || modalKey) {
        return;
      }
      const next = new URLSearchParams(searchParams.toString());
      next.delete("modal");
      const query = next.toString();
      router.replace(query ? `${pathname}?${query}` : pathname, {
        scroll: false
      });
    };
    t2 = [modalKey, modalParam, pathname, router, searchParams];
    $[3] = modalKey;
    $[4] = modalParam;
    $[5] = pathname;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  useEffect(t1, t2);
  if (!modalKey) {
    return null;
  }
  const ModalComponent = MODAL_MAP[modalKey];
  let t3;
  if ($[10] !== router) {
    t3 = () => router.back();
    $[10] = router;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== ModalComponent || $[13] !== t3) {
    t4 = <ModalComponent isOpen={true} onClose={t3} />;
    $[12] = ModalComponent;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}